import theme from "@/styles/theme";
import { Container, Grid, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import CreateMusicBases from "../CreateMusicBases";

export const AboutBases = ({content}) => {
  return (
    <Container maxWidth="xl">
      <Grid
        container
        justifyContent="center"
        sx={{
          backgroundColor: `${
            content.background_color === "lightgrey"
              ? grey[100]
              : content.background_color === "white"
              ? theme.palette.common.white
              : ""
          } !important`,
          py: 3,
          [theme.breakpoints.up("md")]: {
            py: 6,
          },
        }}
      >
        <Grid item xs={10}>
          <Typography
            variant="h3"
            align="center"
            color="common.black"
            component="p"
            sx={{
              mb: 3,
              [theme.breakpoints.up("md")]: {
                mb: 6,
              },
            }}
          >
            {content.headline}
          </Typography>
          <Typography
            variant="body1"
            color="common.black"
            sx={{
              mb: 3,
              [theme.breakpoints.up("md")]: {
                mb: 6,
              },
            }}
          >
            {content.description}
          </Typography>

          <CreateMusicBases />
        </Grid>
      </Grid>
    </Container>
  );
};

export default AboutBases;
